const jwt = require('jsonwebtoken');

const TokenKey = 'LoginToken';

/*
  Storing the token in a locally scoped variable.
  This allows login to work if session storage is disabled.
  This is better than a global variable in that it will keep the same level of exposure as the function scoping below.
*/
let memtoken;

export function saveToken(token) {
  memtoken = token;
  return sessionStorage.setItem(TokenKey, token);
}

export function removeToken() {
  memtoken = undefined;
  return sessionStorage.removeItem(TokenKey);
}

export function retrieveToken() {
  const token = memtoken != null ? memtoken : sessionStorage.getItem(TokenKey);
  if (token != null) {
    const decodedToken = jwt.decode(token);
    const now = Math.floor(Date.now() / 1000);
    const tokenExp = decodedToken.exp;
    if (tokenExp > now) {
      return token;
    }
    removeToken();
    return null;
  }
  return null;
}
